import React, { useEffect } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { useIntl } from 'react-intl';
import { Select } from 'antd';
import messages from 'translations/messages';
import LanguageTag from 'components/LanguageTag';

const QUERY = gql`
  query($customerId: ID, $websiteIds: [ID!]) {
    websites(customerId: $customerId, ids: $websiteIds) {
      id
      url
      language
      languageName
      additionalLanguages {
        id
        url
        language
        languageName
      }
    }
  }
`;

const { Option } = Select;

const WebsiteLanguageSelect = ({ customerId, websiteId, value, onChange, allowClear, ...rest }) => {
  const { formatMessage: $t } = useIntl();

  const { loading, data } = useQuery(QUERY, {
    variables: { customerId, websiteIds: websiteId ? [websiteId] : null },
    skip: !customerId && !websiteId,
  });

  const languages = data?.websites?.reduce((acc, website) => {
    const { additionalLanguages } = website;
    return [
      ...acc,
      website,
      ...additionalLanguages,
    ];
  }, []) || [];

  // Reset value if not found in available options
  useEffect(() => {
    if (!loading && value && !languages.find(language => language.id === value)) {
      onChange(undefined);
    }
  }, [loading, value, languages, onChange]);

  return (
    <Select
      loading={loading}
      value={loading ? undefined : value}
      onChange={onChange}
      showSearch
      optionFilterProp="children"
      placeholder={$t(messages.selectUrl)}
      allowClear={allowClear}
      {...rest}
    >
      {languages.map(l => (
        <Option key={l.id} value={l.id}>
          <LanguageTag {...l} />
          <span>{l.url}</span>
        </Option>
      ))}
    </Select>
  );
};

export default WebsiteLanguageSelect;
